import { Box, Button, Tag, Text } from '@factorialco/deprecated-design-system'
import { ContractTaxonomyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import formatCurrency from 'modules/core/lib/formatCurrency'
import i18n from 'modules/core/lib/i18n'

import { additionalCompensationType } from 'modules/contracts/lib/additionalCompensations'
import type Compensation from 'modules/contracts/store/models/Compensation'

interface Props {
  employeeLegalEntityId: number
  compensation: Compensation
  onEdit: (compensation: Compensation) => void
  taxonomy?: ContractTaxonomyFragment
}

const DeprecatedAdditionalCompensation = observer(
  ({ employeeLegalEntityId, compensation, onEdit, taxonomy }: Props) => {
    const compensationType = additionalCompensationType(compensation.attributes.compensation_type)
    const amount = formatCurrency(
      compensation.attributes.amount,
      undefined,
      null,
      employeeLegalEntityId
    )
    const formatAmountInUnits = (quantityInCents: number, units: string) => {
      const amount = quantityInCents / 100
      return i18n.tp('compensation.unit.units', { count: amount })
    }
    const unit = formatAmountInUnits(compensation.attributes.amount, compensation.attributes.unit)
    const value = compensation.attributes.unit == 'units' ? unit : amount

    return (
      <Box
        background="grey200"
        paddingY="s16"
        paddingX="s32"
        gap="s8"
        flexDirection="column"
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        {compensation.attributes.sync_with_supplements && (
          <Tag type="neutral" inline showCircle leftItem="circle">
            {i18n.t(
              'contract_versions.flows.update.steps.role_level_salary.additional_compensations.synced'
            )}
          </Tag>
        )}
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Box gap="s2">
            <Box flexDirection="row" alignItems="center" gap="s8">
              <Text.Normal weight="medium" size="300" color="grey800">
                {taxonomy?.name}
              </Text.Normal>
              {compensation.attributes.description && (
                <InformationTooltip information={compensation.attributes.description} />
              )}
            </Box>
            <Box flexDirection="row" gap="s4">
              <Text.Normal capitalize weight="semibold" size="200" color="grey800">
                {compensationType}
              </Text.Normal>
              <Text.Normal weight="semibold" size="200" color="grey800">
                {value}
              </Text.Normal>
            </Box>
          </Box>
          <Box justifyContent="center">
            <Button onClick={() => onEdit(compensation)} type="secondary" iconName="settings" />
          </Box>
        </Box>
      </Box>
    )
  }
)

export { DeprecatedAdditionalCompensation }
